import { isPlainObject } from 'lodash-es'

const getValue = (v) => {
  if (v === false) return '否'

  if (v) return '是'

  return ''
}

const transformer = function (origin, defs) {
  if (isPlainObject(origin) && origin.value) {
    return {
      render: 'text',
      origin,
      value: origin.value,
      ...origin,
      defs,
    }
  }

  return {
    render: 'text',
    origin,
    value: getValue(origin),
    defs,
  }
}

export default transformer
